"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Button = exports.ExternalLinkBox = exports.ThemedErrorIcon = exports.StyledCustomTooltip = exports.ThemedWalletIcon = exports.ThemedInfoIcon = exports.ThemedIconButton = exports.ThemedContentCopyIcon = exports.CustomSnackBar = exports.LoadingDataCardContainer = exports.LoadingDataCard = exports.LoadingListCard = exports.LoadingCard = exports.TableWrap = exports.Tag = exports.Tags = exports.Label = exports.CardTitle = exports.Instructions = exports.ThemedSearchIcon = exports.CustomTextField = exports.TransactionTableCell = exports.TransactionTableRow = exports.TransactionLabel = exports.TransactionCardContainer = exports.WalletButton = exports.GridContainer = exports.DataCardValue = exports.DataCardInner = exports.DataCardItem = exports.TooltipLabel = exports.TooltipContainer = exports.CustomCardHeader = exports.CustomLegend = exports.GridChartInner = exports.ChartLoading = exports.ChartContainer = void 0;
const format_1 = require("@/utils/format");
const material_1 = require("@mui/material");
const styled_components_1 = __importDefault(require("styled-components"));
const Search_1 = __importDefault(require("@mui/icons-material/Search"));
const ContentCopy_1 = __importDefault(require("@mui/icons-material/ContentCopy"));
const Info_1 = __importDefault(require("@mui/icons-material/Info"));
const Wallet_1 = __importDefault(require("@mui/icons-material/Wallet"));
const react_1 = __importDefault(require("react"));
const Error_1 = __importDefault(require("@mui/icons-material/Error"));
/*
        CHART
*/
exports.ChartContainer = (0, styled_components_1.default)('div') `
  grid-column: span ${(props) => (props.col ? props.col : '12')};
  background-color: ${(props) => props.theme.colors.altBg};
  padding: 30px;
  border-radius: ${(props) => props.theme.radius.md};
  ${(props) => props.theme.media.lg} {
    padding: ${(props) => props.theme.spacing.margin.lg} 0;
  }
  ${(props) => props.theme.media.md} {
    grid-column: span 12;
  }
  ${(props) => props.theme.media.sm} {
    grid-column: span 12;
  }
  ${(props) => props.theme.media.xs} {
    grid-column: span 12;
  }
`;
exports.ChartLoading = (0, styled_components_1.default)('div') `
  height: 400px;
`;
exports.GridChartInner = (0, styled_components_1.default)('div') `
  grid-column: 1/11;
  gap: 20px;
  height: 350px;
`;
exports.CustomLegend = (0, styled_components_1.default)(material_1.Box) `
  color: ${(props) => props.theme.colors.onBg};
`;
exports.CustomCardHeader = (0, styled_components_1.default)('div') `
  color: ${(props) => props.theme.colors.onBg};
  box-sizing: content-box;
  grid-column: 1/13;
  width: 100%;
  display: flex;
  align-items: center;
  font-weight: 600;
  padding-bottom: ${(props) => props.theme?.spacing?.margin?.xl};
`;
exports.TooltipContainer = (0, styled_components_1.default)(material_1.Box) `
  min-width: 320px;
  padding: 30px;
  border-radius: 50px;
  background-color: ${(props) => props.theme.colors.bg};
  color: ${(props) => props.theme.colors.onBg};
  -webkit-box-shadow: 5px 5px 15px 5px rgba(0, 0, 0, 0.14);
  box-shadow: 5px 5px 15px 5px rgba(0, 0, 0, 0.14);
  outline: none;
  &:focus {
    outline: none;
    border: 2px solid blue;
  }
`;
exports.TooltipLabel = (0, styled_components_1.default)(material_1.Box) `
  padding-bottom: 10px;
  font-weight: 600;
`;
/*
        CARD
*/
exports.DataCardItem = (0, styled_components_1.default)(material_1.Box) `
    color: ${(props) => props.bg
    ? props.theme.colors['on' + (0, format_1.capitalizeFirstLetter)(props.bg)]
    : props.theme.colors.onBg};
    border-radius:  ${(props) => (props.radius ? props.radius + 'px' : props.theme.radius.lg)};
	background: ${(props) => props.theme.colors[`${props.bg}`]};
	margin: ${(props) => props.margin};
    grid-column: span ${(props) => (props.cardwidth?.xl ? props.cardwidth?.xl : 12)};
    display: flex;
	order: ${(props) => props.order};
    flex-direction: column;
	align-items: center;
	position: relative;
	&:hover {
		box-shadow: ${(props) => (props.hover ? `5px 3px 11px 3px rgba(0,0,0,0.19);` : `none;`)}
		border: ${(props) => (props.hover ? `1px solid ${props.theme.colors.border}` : '')};
	}
    border: 1px solid ${(props) => (props.isborder ? props.theme.colors.border : 'transparent')};
	&:before {
        content: "→";
        position: absolute;
        left: -25px;
        display: ${(props) => (props.arrowed ? (props.i !== 0 ? 'block' : 'none') : 'none')};
        font-size: 4em;
    }
    ${(props) => props.theme.media.lg} {
        grid-column: span ${(props) => props.cardwidth?.lg};
    }
    ${(props) => props.theme.media.md} {
        grid-column: span ${(props) => props.cardwidth?.md};
		&:before {
			content: "↓";
			position: absolute;
			top: -50px;
			left: 50%;
			display: ${(props) => (props.arrowed ? (props.i !== 0 ? 'block' : 'none') : 'none')};
			font-size: 4em;
		}
    }
    ${(props) => props.theme.media.sm} {
        grid-column: span ${(props) => props.cardwidth?.sm};
    }
    ${(props) => props.theme.media.xs} {
        grid-column: span ${(props) => props.cardwidth?.xs};
    }
    ${(props) => props.theme.media.lg} {
      padding: ${(props) => props.theme.spacing.margin.lg};
      padding: ${(props) => props.horizontal
    ? `${props.theme.spacing.margin.sm}  ${props.theme.spacing.margin.lg}`
    : props.theme.spacing.margin.lg};
    }
    ${(props) => props.theme.media.md} {
      padding: ${(props) => props.horizontal
    ? `${props.theme.spacing.margin.sm}  ${props.theme.spacing.margin.md}`
    : props.theme.spacing.margin.md};
      padding: ${(props) => props.theme.spacing.margin.md};
    }
    ${(props) => props.theme.media.sm} {
      padding: ${(props) => props.theme.spacing.margin.sm};
      padding: ${(props) => props.horizontal
    ? `${props.theme.spacing.margin.sm}  ${props.theme.spacing.margin.sm}`
    : props.theme.spacing.margin.sm};
    }
    ${(props) => props.theme.media.xs} {
      padding: ${(props) => props.horizontal
    ? `${props.theme.spacing.margin.xs}  ${props.theme.spacing.margin.sm}`
    : props.theme.spacing.margin.sm};
    }
    padding: ${(props) => props.horizontal
    ? `${props.theme.spacing.margin.sm}  ${props.theme.spacing.margin.lg}`
    : props.theme?.spacing?.margin?.xl};
   `;
exports.DataCardInner = (0, styled_components_1.default)('div') `
  width: 100%;
`;
exports.DataCardValue = (0, styled_components_1.default)('p') `
  font-size: 2.725em;
  line-height: 1.1em;
  font-family: 'Prompt', sans-serif;
`;
exports.GridContainer = (0, styled_components_1.default)('div') `
  display: grid;
  grid-column: span 12;
  width: 100%;
  grid-template-columns: repeat(12, 1fr);
  column-gap: 15px;
  row-gap: 15px;
  align-self: flex-end;
  ${(props) => props.theme.media.lg} {
  }
  ${(props) => props.theme.media.md} {
  }
  ${(props) => props.theme.media.sm} {
  }
  ${(props) => props.theme.media.xs} {
  }
`;
exports.WalletButton = (0, styled_components_1.default)('button') `
  color: ${(props) => props.theme.colors.onContrastBg};
  background-color: ${(props) => props.theme.colors.contrastBg};
  font-size: 1em;
  cursor: pointer;
  border: 1px solid ${(props) => props.theme.colors.contrastBg};
  outline: none;
  display: flex;
  width: max-content;
  padding: 10px 20px 5px 20px;
  border-radius: 25px;
  svg {
    margin-left: 15px;
    position: relative;
    top: -2px;
  }
  &:hover {
    border: 1px solid ${(props) => props.theme.colors.border};
  }
`;
exports.TransactionCardContainer = (0, styled_components_1.default)(material_1.Box) `
  overflow: scroll;
  border-radius: 25px;
  overflow: hidden;
  padding: ${(props) => props.theme.spacing.margin.lg};
  color: ${(props) => props.theme.colors.onBg};
  grid-column: span 12;
  border: 1px solid ${(props) => props.theme.colors.border};
  ${(props) => props.theme.media.lg} {
    grid-column: span 12;
    padding: ${(props) => props.theme.spacing.margin.lg};
  }
  ${(props) => props.theme.media.md} {
    overflow-x: scroll;
    padding: ${(props) => props.theme.spacing.margin.md};
  }
  ${(props) => props.theme.media.sm} {
    padding: ${(props) => props.theme.spacing.margin.sm};
  }
  ${(props) => props.theme.media.xs} {
    padding: ${(props) => props.theme.spacing.margin.xs};
  }
`;
exports.TransactionLabel = (0, styled_components_1.default)(material_1.TableCell) `
  max-width: 80px;
  text-transform: capitalize;
  padding: 5px 16px !important;
  color: ${(props) => props.theme.colors.onAltBg};
  &:after {
    content: ':';
  }
`;
exports.TransactionTableRow = (0, styled_components_1.default)(material_1.TableRow) `
  height: 20px;
  width: 100%;
  overflow: hidden;
  div {
    max-height: 25px;
  }
`;
exports.TransactionTableCell = (0, styled_components_1.default)(material_1.TableCell) `
  width: 100%;
  max-height: 20px;
  overflow: hidden;
  padding: 1px 16px !important;
`;
/*
        SEARCH INPUT
*/
exports.CustomTextField = (0, styled_components_1.default)(material_1.TextField) `
  border-radius: 50px;
  max-width: 800px;
  background-color: ${(props) => props.theme.colors.contrastBg};
  & .MuiOutlinedInput-notchedOutline {
    border: 2px solid ${(props) => props.theme.colors.border};
    color: ${(props) => props.theme.colors.onContrastBg} !important;
    border-radius: 50px;
  }
  & .MuiInputBase-root {
    color: ${(props) => props.theme.colors.onContrastBg};
    padding: 2px;
  }
  & .MuiInputAdornment-root {
    padding-right: 15px;
    fill: ${(props) => props.theme.colors.onContrastBg};
    color: ${(props) => props.theme.colors.onContrastBg};
    svg {
      fill: ${(props) => props.theme.colors.onContrastBg};
      color: ${(props) => props.theme.colors.onContrastBg};
    }
  }
`;
exports.ThemedSearchIcon = (0, styled_components_1.default)(Search_1.default) `
  color: ${(props) => props.theme.colors.onContrastBg};
`;
exports.Instructions = (0, styled_components_1.default)(material_1.Box) `
  color: ${(props) => props.theme.colors.onBg};
`;
/*
       COMMON
*/
exports.CardTitle = (0, styled_components_1.default)('h4') `
  font-size: 1em;
  line-height: 1;
  width: min-content;
  font-weight: 600;
  text-transform: Capitalize;
  ${(props) => props.theme.media.lg} {
    font-size: 1em;
    padding: 0;
    line-height: 1;
  }
  ${(props) => props.theme.media.md} {
    font-size: 1em;
    padding: 0;
    line-height: 1;
  }
  ${(props) => props.theme.media.sm} {
    font-size: 1em;
    padding: 0;
    line-height: 1;
  }
  ${(props) => props.theme.media.xs} {
    font-size: 1em;
    padding: 0;
    line-height: 1;
  }
`;
exports.Label = (0, styled_components_1.default)('p') ``;
exports.Tags = (0, styled_components_1.default)('p') ``;
exports.Tag = (0, styled_components_1.default)('div') `
  width: fit-content;
  padding: 7px 13px;
  background-color: ${(props) => props.theme.colors.contrastBg};
  display: inline-flex;
  justify-content: center;
  align-items: center;
  color: ${(props) => props.theme.colors.onContrastBg};
  border-radius: 50px;
  margin: 10px 0;
  margin-right: 10px;
  font-size: 0.82em;
`;
exports.TableWrap = styled_components_1.default.div `
  width: 100%;
  overflow: auto;
`;
exports.LoadingCard = (0, styled_components_1.default)('div') `
  border-radius: 20px;
  margin-bottom: 20px;
  @media (max-width: 768px) {
    width: 100%;
  }
`;
exports.LoadingListCard = (0, styled_components_1.default)('div') `
  border-radius: 20px;
  padding-left: 20px;
  width: 100%;
  height: 500px;
`;
exports.LoadingDataCard = (0, styled_components_1.default)('div') `
  height: 120px;
`;
exports.LoadingDataCardContainer = (0, styled_components_1.default)('div') `
  justify-content: space-between;
  height: 100px;
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 20px;
  width: 100%;
`;
/*
        INTERACTIONS/FEEDBACK
*/
exports.CustomSnackBar = (0, styled_components_1.default)(material_1.Snackbar) `
  border-radius: 20px;
  background-color: ${(props) => props.theme.colors.contrastBg};
  color: ${(props) => props.theme.colors.onContrastBg};
  .MuiPaper-root {
    background-color: ${(props) => props.theme.colors.contrastBg};
    border-radius: 20px;
    color: ${(props) => props.theme.colors.onContrastBg};
  }
  .MuiAlert-icon {
    fill: #fff;
    color: #fff !important;
  }
`;
exports.ThemedContentCopyIcon = (0, styled_components_1.default)(ContentCopy_1.default) `
  color: ${(props) => props.theme.colors.table.text} !important;
`;
exports.ThemedIconButton = (0, styled_components_1.default)(material_1.IconButton) `
  .MuiSvgIcon-root {
    width: 20px;
  }
`;
exports.ThemedInfoIcon = (0, styled_components_1.default)(Info_1.default) `
  fill: ${(props) => props.theme.colors.onBg} !important;
  opacity: 0.4;
`;
exports.ThemedWalletIcon = (0, styled_components_1.default)(Wallet_1.default) `
  fill: ${(props) => props.theme.colors.onBg} !important;
  opacity: 0.4;
`;
exports.StyledCustomTooltip = (0, styled_components_1.default)(({ className, ...props }) => (react_1.default.createElement(material_1.Tooltip, { ...props, classes: { popper: className } })))(({ theme }) => {
    return {
        [`& .${material_1.tooltipClasses.tooltip}`]: {
            backgroundColor: theme.colors.contrastBg,
            color: theme.colors.onContrastBg,
            fontSize: '1em',
            whiteSpace: 'pre-line',
            lineHeight: '1.2em',
            padding: '15px 17px',
            borderRadius: '20px',
        },
    };
});
exports.ThemedErrorIcon = (0, styled_components_1.default)(Error_1.default) `
  color: ${(props) => props.theme.colors.table.text} !important;
`;
exports.ExternalLinkBox = styled_components_1.default.div `
  padding: 0 7px 0 20px;
  border-radius: 50px;
  text-decoration: none;
  height: 50px;
  display: flex;
  align-items: center;
  border: 1px solid ${(props) => props.theme.colors.contrastBg};
  justify-content: space-between;
  background-color: ${(props) => props.theme.colors.contrastBg};
  color: ${(props) => props.theme.colors.onContrastBg};
  &:hover {
    color: #fff;
    border: 1px solid ${(props) => props.theme.colors.border};
  }
`;
exports.Button = styled_components_1.default.div `
  padding: 0 20px;
  border-radius: 50px;
  text-decoration: none;
  height: 50px;
  display: flex;
  align-items: center;
  border: 1px solid ${(props) => props.theme.colors.contrastBg};
  justify-content: space-between;
  background-color: ${(props) => props.theme.colors.contrastBg};
  color: ${(props) => props.theme.colors.onContrastBg};
  &:hover {
    color: #fff;
    border: 1px solid ${(props) => props.theme.colors.border};
  }
`;
